import PropTypes from 'prop-types'

import {Body1} from '@adv-mt/ui/typography'

import {BASE_CLASS} from './config.js'

const AdInfoContent = ({price, title}) => {
  return (
    <div className={`${BASE_CLASS}-adInfo`}>
      {price && (
        <Body1 highlight className={`${BASE_CLASS}-adInfo-price`}>
          {price}
        </Body1>
      )}
      {price && title && (
        <span aria-hidden="true" className={`${BASE_CLASS}-adInfo-separator`}>
          ·
        </span>
      )}
      {title && (
        <Body1 highlight className={`${BASE_CLASS}-adInfo-title`}>
          {title}
        </Body1>
      )}
    </div>
  )
}

AdInfoContent.displayName = 'AdInfoContent'
AdInfoContent.propTypes = {
  price: PropTypes.string,
  title: PropTypes.string
}

export default AdInfoContent
